module.exports = __webpack_public_path__ + "eeadd2b85e39f40a06d0cbcbc0d22191.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/signature/signature-autumn-2012-page-001.jpg
 ** module id = 468
 ** module chunks = 0
 **/